export default "__VITE_ASSET__BJf8fYqy__"